<template>
    <div>
        <b-navbar toggleable="md" class="navbar">
            <b-navbar-brand class="col-md-3">
                <router-link to="/">
                    <img class="logo" src="@/assets/clubsaway-logo-mobile.svg">
                </router-link>

                <!-- clubsaway logo -->
            </b-navbar-brand>
            <b-navbar-toggle target="nav_collapse"/>

            <b-collapse is-nav id="nav_collapse">
                <b-navbar-nav>
                    <b-nav-item to="/client/events">
                        Manage Events
                    </b-nav-item>
                </b-navbar-nav>

                <b-navbar-nav class="ml-auto">
                    <b-nav-item-dropdown right>
                        <template slot="button-content">
                            {{ user.name }}
                        </template>

                        <b-dropdown-item to="/client/profile">
                            Your Profile
                        </b-dropdown-item>

                        <b-dropdown-item href="#" @click="logout()">
                            Log Out
                        </b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>


        <div class="py-5 content-area">
            <router-view></router-view>
        </div>
        <tb-footer></tb-footer>
    </div>
</template>

<script>
    import TbFooter from '@/views/Footer.vue';
    import {api} from "@/repository/repository.js";
    export default {
        components: {
            TbFooter
        },
        computed: {
            user() {
                return this.$store.getters.user;
            }
        },

        methods: {
            logout() {
                api.get('/logout')
                    .then(response=>{
                        window.location = '/';
                        //
                    });
            }
        }
    }
</script>

<style scoped>
    .logo {
        max-width: 300px;
    }
    a.router-link-active {
        color: white!important;
    }
    .content-area{
        min-height: calc(100vh - 18rem);
    }
</style>